// extracted by mini-css-extract-plugin
export var buttonBadge = "PGfB8";
export var buttonFullBleed = "oq3St";
export var buttonIcon = "jxKmP";
export var headerButton = "TXRvx";
export var overflowContainer = "rO0nz";
export var resizableArea = "djbNn";